module.exports = __webpack_public_path__ + "start.one.player.png";